<template>
  <div style="width: 600px; height: 387px" id="container"></div>
</template>
<script setup>
import { onUnmounted, ref, defineExpose } from "vue";
import cat from "../../assets/services/cat.png";
import AMapLoader from "@amap/amap-jsapi-loader";
const show = ref(false);
let map = null;
let endMarker = null;
let infoWindow = null;
//实例化信息窗体
var title = "车辆信息",
  content = ["上海市宝山区同济路669弄（宝杨宝龙广场）T3写字楼1002-1003室"];
function init() {
  AMapLoader.load({
    key: "6de02e8aa5b66991d186b85cf06641b7", // 申请好的Web端开发者Key，首次调用 load 时必填
    version: "2.0", // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
    plugins: [], // 需要使用的的插件列表，如比例尺'AMap.Scale'等
  }).then((AMap) => {
    var position = new AMap.LngLat(121.4821, 31.39449);

    map = new AMap.Map("container", {
      // 设置地图容器id
      viewMode: "2D", // 是否为3D地图模式
      zoom: 18, // 初始化地图级别
      zooms: [4, 20],
      center: position, // 初始化地图中心点位置
    });
    // 创建一个 icon
    var endIcon = new AMap.Icon({
      size: new AMap.Size(34, 34),
      image: cat,
      imageSize: new AMap.Size(22, 22),
      imageOffset: new AMap.Pixel(0, 0),
    });

    // 将 icon 传入 marker
    endMarker = new AMap.Marker({
      position: position,
      icon: endIcon,
      offset: new AMap.Pixel(-15, -15),
    });

    endMarker.on("click", function () {
      infoWindow.open(map, endMarker.getPosition());
    });
    // 自定义窗口
    infoWindow = new AMap.InfoWindow({
      isCustom: true, //使用自定义窗体
      content: createInfoWindow(title, content.join("<br/>")),
      offset: new AMap.Pixel(16, -35),
    });

    map.add([endMarker]);

    getData();
  });
}
function closeInfoWindow() {
  map.clearInfoWindow();
}
function getData() {
  infoWindow.open(map, endMarker.getPosition());
}
//构建自定义信息窗体
function createInfoWindow(title, content) {
  var info = document.createElement("div");
  info.className = "custom-info input-card content-window-card";

  //可以通过下面的方式修改自定义窗体的宽高
  info.style.width = "400px";
  // 定义顶部标题
  var top = document.createElement("div");
  top.className = "disna";
  var titleD = document.createElement("div");
  var closeX = document.createElement("img");
  top.className = "info-top fasfasf";
  titleD.innerHTML = title;
  closeX.src = "https://webapi.amap.com/images/close2.gif";
  closeX.onclick = closeInfoWindow;

  top.appendChild(titleD);
  top.appendChild(closeX);
  info.appendChild(top);
  // 定义中部内容
  var middle = document.createElement("div");
  middle.className = "info-middle";
  middle.style.backgroundColor = "white";
  middle.innerHTML = content;
  info.appendChild(middle);

  // 定义底部内容
  var bottom = document.createElement("div");
  bottom.className = "info-bottom";
  bottom.style.position = "relative";
  bottom.style.top = "0px";
  bottom.style.margin = "0 auto";
  var sharp = document.createElement("img");
  sharp.src = "https://webapi.amap.com/images/sharp.png";
  bottom.appendChild(sharp);
  info.appendChild(bottom);
  return info;
}

onUnmounted(() => {
  map?.destroy();
});
function open() {
  show.value = true;
}
init();
defineExpose({ open, init });
</script>

<style scoped>
:deep(.content-window-card) {
  position: relative;
  box-shadow: none;
  bottom: 0;
  left: 0;
  width: auto;
  padding: 0;
}

:deep(.content-window-card p) {
  height: 2rem;
}

:deep(.custom-info) {
  border: solid 1px silver;
}

:deep(div.info-top) {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #efefef;
  height: 35px;
  padding: 0px 8px;
  border-bottom: 1px solid #c3c3c3;
  font-size: 15px;
  font-weight: 900;
}

:deep(div.info-top div) {
  display: inline-block;
  color: #333333;
  font-size: 14px;
  font-weight: bold;
  line-height: 31px;
  padding: 0 10px;
}

:deep(div.info-top img) {
  position: absolute;
  top: 10px;
  right: 10px;
  transition-duration: 0.25s;
}

:deep(div.info-top img:hover) {
  box-shadow: 0px 0px 5px #000;
  cursor: pointer;
}

:deep(div.info-middle) {
  font-size: 12px;
  padding: 10px 18px;
  line-height: 20px;
  text-align: left;
}

:deep(div.info-bottom) {
  height: 0px;
  width: 100%;
  clear: both;
  text-align: center;
}

:deep(div.info-bottom img) {
  position: relative;
  z-index: 104;
}

:deep(span) {
  margin-left: 5px;
  font-size: 11px;
}

:deep(.info-middle img) {
  float: left;
  margin-right: 6px;
}

#container {
  width: 100%;
  height: 800px;
}
:deep(.el-dialog__body) {
  padding: 0px;
}
.btn {
  cursor: pointer;
  padding: 3px 5px;
  background-color: rgb(76, 120, 155);
  color: #fff;
  border: 1px solid rgba(0, 0, 0, 0);
  border-radius: 2px;
}
</style>
